// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { BookingInTicketingReportSearchResultComponent } from './booking-in-ticketing-report-search-result.component';
import { TicketingReportSearchResultRouting } from './ticketing-report-search-result.routing';
import { BookingResultsContainerModule } from '../booking-search-result/components/booking-results-container/booking-results-container.module';
import { DateModule } from 'libraries/module/formbuilder/fields/date/date.module';
import { TicketResourceModule } from 'app_sasha/shared/resources/ticket/ticketResource.module';
import { SashaBreadcrumbModule } from 'app_sasha/shared/components/breadcrumb/sasha-breacrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { LabelModule } from 'libraries/service/label/label.module';

@NgModule({
    imports: [
        CommonModule,
        TicketingReportSearchResultRouting,
        BookingResultsContainerModule,
        DateModule,
        TicketResourceModule,
        SashaBreadcrumbModule,
        TitleServiceModule,
        LabelModule,
    ],
    exports: [
        BookingInTicketingReportSearchResultComponent,
    ],
    declarations: [BookingInTicketingReportSearchResultComponent],
    providers: [],
})
export class BookingInTicketingReportSearchResultModule { }
